import React, { useState, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../services/apis";
import { Menu, Icon, Button, Header, Modal } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  ContainerInputSearch,
  Input,
  CreateButton,
  SemanticTable,
  SemanticButton,
  Image,
} from "./styles";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../services/auth";

const Consultores = (props) => {
  const [open, setOpen] = useState(false);
  const [consultores, setConsultores] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    loadConsultores();
  }, []);

  const loadConsultores = async () => {
    try {
      const params = {
        all: 1,
      };

      const res = await api.get("consultor", { params });

      setConsultores(res.data);
    } catch (err) {
      console.error(err);
      swal("Não foi possível carregar os consultores", "", "").then((res) =>
        props.history.push("/")
      );
    }
  };

  const removeConsultor = useCallback(
    (id) => {
      swal({
        title: "Remoção de consultor",
        text: "Você tem certeza que quer remover ?",
        buttons: true,
        icon: "warning",
        dangerMode: true,
      }).then((res) => {
        if (!res) {
          return;
        }

        api.delete(`admin/consultor/${id}`).then((res) => {
          const newconsultores = [...consultores].filter(
            (consultor) => consultor.id !== id
          );
          setConsultores(newconsultores);
        });
      });
    },
    [consultores]
  );

  const handleStatus = useCallback(
    (index) => {
      const newConsultores = [...consultores];
      newConsultores[index].ativo =
        newConsultores[index].ativo === "S" ? "N" : "S";

      api
        .put(
          `admin/consultor/${newConsultores[index].id}`,
          newConsultores[index]
        )
        .then((res) => setConsultores(newConsultores))
        .catch((err) => console.error(err));
    },
    [consultores]
  );

  return (
    <Container>
      <AdminMenu />

      <Content>
        <Title>Consultores</Title>

        <ContainerInputSearch className="ui fluid left icon input">
          <Input
            type="search"
            placeholder="Procurar consultor..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <Icon name="search icon" />

          <CreateButton to="consultores/criar">Criar</CreateButton>
        </ContainerInputSearch>

        <SemanticTable size="big" celled>
          <SemanticTable.Header>
            <SemanticTable.Row>
              <SemanticTable.HeaderCell>Id</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Foto</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Nome</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Status</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Ações </SemanticTable.HeaderCell>
            </SemanticTable.Row>
          </SemanticTable.Header>

          <SemanticTable.Body>
            {consultores
              .filter((consultor) =>
                consultor.nome.toLowerCase().includes(search.toLowerCase())
              )
              .map((consultor, index) => (
                <SemanticTable.Row>
                  <SemanticTable.Cell>{consultor.id}</SemanticTable.Cell>
                  <SemanticTable.Cell>
                    <Image
                      src={
                        consultor.imagem[0] === "/"
                          ? `https://www.voitto.com.br${consultor.imagem}`
                          : consultor.imagem
                      }
                    />
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>{consultor.nome}</SemanticTable.Cell>
                  <SemanticTable.Cell>
                    <a onClick={() => handleStatus(index)}>
                      {consultor.ativo === "S" ? "Ativo" : "Inativo"}
                    </a>
                  </SemanticTable.Cell>

                  <SemanticTable.Cell>
                    <>
                      <Button
                        icon="edit icon"
                        color={"blue"}
                        onClick={() =>
                          window.open(
                            `/admin/consultores/detalhes/${consultor.id}`
                          )
                        }
                      />

                      <Button
                        icon="trash icon"
                        color={"red "}
                        onClick={() => removeConsultor(consultor.id)}
                      />
                    </>
                  </SemanticTable.Cell>
                </SemanticTable.Row>
              ))}
          </SemanticTable.Body>
        </SemanticTable>
      </Content>
    </Container>
  );
};

export default withRouter(Consultores);
